export { default as fbIcon } from "./facebook.svg";
export { default as igIcon } from "./instagram.svg";
export { default as logo } from "./logo.png";
export { default as ttIcon } from "./tiktok.svg";
